class menuMobile extends ListeResultat {
	initialize(windowWidth, init) {

		const MENU_NAVIGATION = document.getElementById('menuNavigation');
		const utilities = new utilitiesListeResultat();
		let self = this;

		if (windowWidth < 1024) {
			this.template(MENU_NAVIGATION);
			this.toggleSubMenu(MENU_NAVIGATION);
			this.stickyNavbar(utilities, windowWidth);
		}

		this.stickyFiltres(utilities, windowWidth);
		// On met la variable à true pour eviter de relancer la function déjà initialisée
		init = true;
	}
	stickyNavbar(tools, windowWidth) {

		if (settingsListeResultats.resultats.nbreVoyages > 1) {
			let derniere_position_de_scroll_connue = 0,
				ticking = false;

			window.addEventListener('scroll', function (e) {
				derniere_position_de_scroll_connue = window.scrollY;
				if (!ticking) {
					window.requestAnimationFrame(function () {
						stickMenu(derniere_position_de_scroll_connue);
						ticking = false;
					});
				}

				ticking = true;
			});

			function stickMenu(y) {
				if (y >= tools.offset(document.body).height) {
					document.querySelector('.menu-navigation').classList.add('is-sticked');
				} else {
					document.querySelector('.menu-navigation').classList.remove('is-sticked');
				}
			}
		}
	}
	stickyFiltres(tools, windowWidth) {
		let positionTopFiltre = 0,
			delay = settingsListeResultats.delay + 100,
			idBlockFiltres = 'blockFiltre';

		// Comme la présentation est masquée avec un décalage de ${settings.delay}, on calcule la position top des différents blocs avec un décalage de 100ms
		setTimeout(function () {
			if (document.getElementById(idBlockFiltres).length !== 0) {
				positionTopFiltre = tools.offset(document.getElementById(idBlockFiltres)).top;
			}
		}, delay);

		if (document.querySelector('.section--presentation .lr__more') !== null) {
			document.querySelector('.section--presentation .lr__more').addEventListener('click', function () {
				positionTopFiltre = tools.offset(document.getElementById(idBlockFiltres)).top;
			});
		}

		if (settingsListeResultats.resultats.nbreVoyages > 1) {
			window.onscroll = function () {
				///
				/// Barre des filtres
				///
				if (window.scrollY >= positionTopFiltre) {
					document.getElementById(idBlockFiltres).classList.add('is-sticked');
				} else {
					document.getElementById(idBlockFiltres).classList.remove('is-sticked');
				}
			}
		}
	}

	toggleSubMenu(menu) {

		let li = [...menu.querySelectorAll('.menu__child')];

		const setActive = el => {

			let isOpen = el.className.indexOf('is-active') >= 0 ? true : false;
			[...el.parentElement.children].forEach(sib => sib.classList.remove('is-active'));

			!isOpen && menu.removeAttribute('style');
			!isOpen && el.classList.add('is-active');

			if (el.id == 'menuLinkingRegions' || el.id == 'menuLinkingActivites' || el.id == 'isAriane') {
				/// Positionnement du sous-menu
				let leftPos = Math.max(0, el.offsetLeft - menu.scrollLeft - 20 + 7);
				let ul = el.querySelector('ul');

				if (ul != null) {
					// Si l'item suggestion existe, on cale le sous-menu à droite
					if (document.getElementById('suggestions') !== null && menu.clientWidth < 450) {
						ul.style.right = 0;
					} else {
						ul.style.left = leftPos + 'px';
					}

					if (!isOpen)
						menu.style.overflowX = 'initial';
					else
						menu.removeAttribute('style');
				}
			} else if (el.dataset.link != undefined) {
				window.location.href = "#" + el.dataset.link;
			}
		}

		li.forEach(el => el.addEventListener('click', e => setActive(el)))
	}

	template(menu) {
		let self = this;

		const fragment = document.getElementById('menuNavigationTemplate');
		const instance = document.importNode(fragment.content, true);
		document.getElementById('menuNavigation').appendChild(instance);

		let boxLinkingRegions = document.getElementById('boxLinkingDestinations');
		if (boxLinkingRegions != null) {
			let contentHtml = '',
				typeDestinations = 'Régions';

			typeDestinations = boxLinkingRegions.getAttribute('data-destinations') === 'is-regions' ? typeDestinations : 'Pays';
			contentHtml += '<span class="menu__item">' + typeDestinations + '</span><ul>' + self._getContent(boxLinkingRegions) + '</ul>';
			document.getElementById('menuLinkingRegions').innerHTML = contentHtml;
			document.getElementById('menuLinkingRegions').querySelectorAll('li').forEach(el => {
				delete el.querySelector('a').dataset.expandLink;
				el.querySelector('a').classList.remove('card__link')
			});
		}

		let boxLinkingActivites = document.getElementById('boxLinkingActivites');
		if (boxLinkingActivites != undefined) {
			let contentHtml = '';
			contentHtml += '<span class="menu__item">Activités</span><ul>' + self._getContent(boxLinkingActivites) + '</ul>';
			document.getElementById('menuLinkingActivites').innerHTML = contentHtml;
			document.getElementById('menuLinkingActivites').querySelectorAll('li').forEach(el => {
				delete el.querySelector('a').dataset.expandLink;
				el.querySelector('a').classList.remove('card__link')
			});
		}
	}

	_getContent(element) {
		let list = '';
		element.querySelectorAll('li').forEach(el => {
			list += `<li>${el.querySelector('a').outerHTML}</li>`;
		});
		return list;
	}
}